import { isEqual } from 'lodash'

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Set the value at path of object modifying the original
 * @param object Object to be modified
 * @param propertyPath Object's path string, separatted by dot
 * @param value Final value to be assigned to the last "property / key" from received "path"
 */
function setNestedPropertyFrom(object: any, propertyPath: string, value: unknown) {
  const keys = propertyPath.split('.')
  if (!keys) return
  keys.forEach((x, i) => {
    object[x] = i === keys.length - 1 ? value : {}
    object = object[x]
  })
}

/**
 * Access nested property by string
 * @param object Object to be access
 * @param propertyPath Object's path string, separatted by dot
 */
function getNestedPropertyFrom(object: any, propertyPath: string) {
  let responseObject = { ...object }
  const pathToken = propertyPath.split('.')
  for (let i = 0, b = pathToken.length; i < b; ++i) {
    const pathProperty = pathToken[i]
    if (pathProperty in responseObject) {
      responseObject = responseObject[pathProperty]
    } else {
      return
    }
  }
  return responseObject
}

export function deepEqualWithPathFilter(a, b, filter: (k: string, lv: unknown, rv: unknown) => boolean, prefix = '') {
  if (a === b) return true
  if (typeof a !== typeof b) return false
  if (!a && !b) return true
  if (typeof a === 'object' && a !== null) {
    if (!b) return false
    if (Array.isArray(a)) {
      if (a.length !== b.length) return false
      for (let i = 0; i < a.length; i++) {
        const itemKey = prefix ? `${prefix}.${i}` : String(i)
        if (!deepEqualWithPathFilter(a[i], b[i], filter, itemKey)) return false
      }
      return true
    }
    for (const key in a) {
      const itemPath = prefix ? `${prefix}.${key}` : key
      if (!filter(itemPath, a[key], b[key])) continue
      if (!deepEqualWithPathFilter(a[key], b[key], filter, itemPath)) return false
    }
    return true
  }
  return a === b
}

export function compareSelectively<T>(a: T, b: T, filters: Array<keyof T | ((v: T) => unknown)>) {
  for (const filter of filters) {
    if (typeof filter === 'function') {
      if (!isEqual(filter(a), filter(b))) return false
    } else {
      if (a[filter] !== b[filter]) return false
    }
  }
  return true
}
export { setNestedPropertyFrom, getNestedPropertyFrom }
